<template>
  <list-header title="Promotion Services" />
  <smart-image
    v-if="init?.promotionBanner"
    :imageURL="init?.promotionBanner"
    class="style-slide-img d-block w-100 rounded-3"
  />
</template>

<script>
import ListHeader from "@/components/ListHeader.vue";
import SmartImage from "@/components/SmartImage.vue";
import { mapGetters } from "vuex";

export default {
  name: "PromotionServices",
  components: {
    ListHeader,
    SmartImage,
  },
  computed: {
    ...mapGetters(["init"]),
  },
};
</script>
<style scoped>
.style-slide-img {
  max-height: 140px;
  max-width: 100%;
  object-fit: cover;
}
</style>
